// Copyright (c) Bentley Systems
import { ColumnDo } from "./column-do";

export class ElistDataModel {
  public columns: ColumnDo[] = [];
  public values: any[][] = [];

  constructor(initializer?: any) {
    if (!initializer) {return;}
    if (initializer.columns) {this.columns = initializer.columns;}
    if (initializer.values) {this.values = initializer.values;}
  }
}
